import React, { useEffect, useState, useMemo } from "react";

import { Wrapper, Card, Row, Spin, Copy } from "app/NativeComponents/common";
import { DragDropList, Select } from "app/NativeComponents/snippets";

import ListItem from "./ListItem";

const phoneColumnFormatOptions = [
  { label: "Multiple Columns", value: "split" },
  { label: "Single Column", value: "single" }
];
const ListView = ({ ...props }) => {
  const phoneColumn = useMemo(
    () => props.list_columns.find(c => c.slug == "phone_numbers") || {},
    [props.list_columns]
  );
  const [phoneColumnFormat, setPhoneColumnFormat] = useState(
    phoneColumnFormatOptions.find(o => o.value == phoneColumn.column_format) ||
      phoneColumnFormatOptions[0]
  );

  useEffect(() => {
    if (!phoneColumn) return;
    props.updateListItemFormat(phoneColumn, phoneColumnFormat.value);
  }, [JSON.stringify(phoneColumnFormat)]);

  const checkColumnSearch = column_title => {
    if (props.column_search && props.column_search.length > 0) {
      if (
        column_title
          .toLowerCase()
          .startsWith(props.column_search.toLowerCase().trim())
      ) {
        return true;
      } else {
        return false;
      }
    }
    return true;
  };

  const renderMainColumn = () => {
    if (props.list_columns[0]) {
      if (checkColumnSearch(props.list_columns[0].title)) {
        return (
          <ListItem
            key={props.list_columns[0].id}
            item={props.list_columns[0]}
            list_columns={props.list_columns}
            checkListItem={props.checkListItem}
            colors={props.colors}
          />
        );
      }
    }
  };

  const getItemExtraForColumn = column => {
    switch (column.slug) {
      case "phone_numbers":
        return () => (
          <Select
            items={phoneColumnFormatOptions}
            title={"Phone Column Format"}
            label="Select an option"
            value={phoneColumnFormat.value}
            text={phoneColumnFormat.label}
            style={{ padding: 0, marginRight: 10 }}
            onSelect={value => {
              setPhoneColumnFormat(
                phoneColumnFormatOptions.find(o => o.value === value) ||
                  phoneColumnFormatOptions[0]
              );
            }}
          />
        );
      default:
        return null;
    }
  };

  if (props.list_columns) {
    if (props.list_columns.length > 0) {
      return (
        <Card>
          {renderMainColumn()}
          <DragDropList
            id="list_columns_draggable"
            rowNumber={1}
            style={{ flex: 1 }}
            items={props.list_columns}
            infiniteScroll={true}
            itemStruture={({ item }) => {
              if (item.main_column !== true && checkColumnSearch(item.title)) {
                return (
                  <ListItem
                    key={item.id}
                    item={item}
                    list_columns={props.list_columns}
                    checkListItem={props.checkListItem}
                    colors={props.colors}
                    ItemExtra={getItemExtraForColumn(item)}
                  />
                );
              }
            }}
            handleReorder={data => {
              props.reorderItems(data);
            }}
            canRefresh={false}
            onRefresh={() => {}}
            is_refreshing={false}
            canLoadMore={false}
            isLoadingMore={false}
            onLoadMore={() => {}}
          />
        </Card>
      );
    }
  }

  if (props.list_columns.length === 0) {
    return (
      <Wrapper>
        <Wrapper
          style={{
            padding: 20,
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Row>
            <Spin size="small" />
            <Copy style={{ marginLeft: 10 }}>Loading...</Copy>
          </Row>
        </Wrapper>
      </Wrapper>
    );
  }

  return <Wrapper />;
};
export default ListView;
